module.exports = __webpack_public_path__ + "static/media/vision-icon-starting.c4ef0339.png";